import { Grid } from "@mui/material";
import React, { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import SuggestionBox from "../../../common/suggestionBox/SuggestionBox";
import FamilyBar from "../../../components/yourAssets/FT/FamilyBar";
import FamilyChart from "../../../components/yourAssets/FT/FamilyChart";
import { getSBTextStatus } from "../../../utils/statusViewUtilities";
import { getFtTabStatus } from "../../../services/yourAssets/CommonServices";
import { visited } from "../../../redux/slices/features/ftOnBoardingSlice";
import { getFtOnBoardingList } from "../../../redux/slices/features/ftOnBoardingSlice";
import "../yourAssets.scss";
import ZoomComponent from "../../../common/ZoomComponent";
import { Box } from "@mui/system";
import FamilyTreeTutorial from "../../../common/FamilyTreeTutorial";
const FamilyTree = () => {
  const [showDetails, setShowDetails] = useState(false);
  const [refresh, setRefresh] = useState(false);
  const [zoomScale, setZoomScale] = useState(1);
  const [isTutorialEnable, setIsTutorialEnable] = useState(false);
  const [tutorialShow, setTutorialShow] = useState({
    add: false,
    edit: false,
    root: false,
  });
  const [otherTutorialShow, setOtherTutorialShow] = useState(false);
  const otherRef = useRef();
  const handleRefresh = () => {
    setRefresh((pre) => !pre);
  };
  const handleZoom = (type) => {
    setIsTutorialEnable(false);
    let zoomValue = zoomScale;
    if (type == "in") {
      setZoomScale(zoomValue + 0.2);
    } else if (type == "out") {
      setZoomScale(zoomValue - 0.2);
    }
  };
  const mainText = useSelector(
    (state) => state.ftOnBoarding.fTSuggestionBoxText
  );
  const dispatch = useDispatch();
  useEffect(() => {
    (async () => {
      dispatch(getFtOnBoardingList());
    })();
  }, []);

  const handleTutorialShow = (obj) => setTutorialShow({ ...obj });
  const handleOtherTutorialShow = (val) => setOtherTutorialShow(val);

  const handleIsTutorialEnable = () => setIsTutorialEnable(false);
  useEffect(() => {
    Object.values(tutorialShow).every((elem) => elem === false) &&
      isTutorialEnable &&
      !otherTutorialShow &&
      handleIsTutorialEnable();
  }, [
    tutorialShow.root,
    tutorialShow.edit,
    tutorialShow.add,
    otherTutorialShow,
  ]);

  return (
    <>
      <Grid
        container
        spacing={5}
        sx={{
          marginTop: "0.5rem",
          minHeight:"87vh",
        }}
        className="family-tree-grid home-fill"
      >
        <Grid item lg={8} md={12} sm={12} xs={12} className="left-side">
          <FamilyChart
            zoomScale={zoomScale}
            handleParentRefresh={handleRefresh}
            isTutorialEnable={isTutorialEnable}
            showTutorial={mainText[0]}
            ref={otherRef}
            setVisited={visited}
            tutorialShow={tutorialShow}
            handleTutorialShow={handleTutorialShow}
            handleOtherTutorialShow={handleOtherTutorialShow}
          />
        </Grid>
        <Grid item lg={4} md={12} sm={12} xs={12} className="right-side">
          <FamilyBar
            refreshFromParent={refresh}
            isTutorialEnable={isTutorialEnable}
            ref={otherRef}
            otherTutorialShow={otherTutorialShow}
            handleOtherTutorialShow={handleOtherTutorialShow}
          />
          <Box
            sx={{
              display: "flex",
              justifyContent: "flex-end",
              marginTop: "20px",
            }}
          >
            <ZoomComponent handleZoom={handleZoom} />
          </Box>
        </Grid>
      </Grid>
      <SuggestionBox
        mainText={mainText[0]}
        tabName="FamilyTree"
        next={showDetails}
        setVisited={visited}
        click={() => {
          setShowDetails(!showDetails);
        }}
      />
      <FamilyTreeTutorial
        handleClick={() => setIsTutorialEnable(!isTutorialEnable)}
      />
    </>
  );
};

export default FamilyTree;
